import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
@Component({
  selector: 'app-view-media-plan',
  templateUrl: './view-media-plan.component.html',
  styleUrls: ['./view-media-plan.component.scss']
})
export class ViewMediaPlanComponent implements OnInit {
  showComponentLoader = false;
  mediaPlanData:any;
  constructor(
      private dialogRef: MatDialogRef<ViewMediaPlanComponent>,
      @Inject(MAT_DIALOG_DATA) public data
  ) { 

    this.mediaPlanData = this.data
    // console.log(this.mediaPlanData)
   
  }

  ngOnInit() {
  }
close(){
  this.dialogRef.close()
}
CommaInNumber(number: any) {
 
  if(number != null){
    number = Number(number)
    let temp = number.toLocaleString("en-IN");
    return temp;
  }
}
download(link:any,name:any){
  this.showComponentLoader = true;
fetch(link)
    .then(response => response.blob())
    .then(blob => {

        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        this.showComponentLoader = false;
    })
    .catch(error => console.error('Download error:', error));
  }
}
